import { type PropsWithChildren } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';

import { apiSwr } from '_api';

export const SwrProvider = (Props: PropsWithChildren) => {
    const { children } = Props;

    return (
        <QueryClientProvider client={apiSwr}>
            {children}
        </QueryClientProvider>
    );
};
